import { Box } from "@mui/material"
import type { FC } from "react"
import { useFormContext } from "react-hook-form"

import type { ContactQueryableFields, Location } from "@/graphql/codegen/graphql"
import { LocationCheckbox } from "@/screens/Companies/components/filters/contact/LocationCheckbox"

interface LocationsFilterProps {
  locations: Location[]
  onFilterChange: (name: keyof ContactQueryableFields, value: string[]) => void
}

export const LocationsFilter: FC<LocationsFilterProps> = ({ onFilterChange, locations }) => {
  const { watch, setValue } = useFormContext()

  // Watch the array of selected locations
  const contactLocationsValue = watch("locationIds") || []

  // Update form value on checkbox change
  const handleFilterChange = (newValue: string[]) => {
    setValue("locationIds", newValue)
    onFilterChange("locationIds", newValue)
  }

  return (
    <Box display='flex' flexDirection='column' height='100%'>
      <Box className='flex max-h-72 grow flex-col overflow-y-auto px-8 py-2'>
        {locations.length &&
          locations.map((location, idx) => (
            <LocationCheckbox
              key={location.locationId + idx}
              location={location}
              value={contactLocationsValue}
              onChange={handleFilterChange}
            />
          ))}
      </Box>
    </Box>
  )
}
